// React and Redux imports
import { useDispatch, useSelector } from 'react-redux';

// Chakra UI components
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

// Actions and constants
import { deleteClassAction } from 'store/modules/class/class-action';
import { classActions } from 'store/modules/class/class-slice';
import { ReducerStatus } from 'utils/constants';

// Common components
import ResultModal from 'components/common/modals/ResultModal';

function DeleteClassMd() {
  const dispatch = useDispatch();

  const deleteClass = useSelector((state) => state.class.deleteClass);

  const handleToggleDeleteModal = (isOpen) => {
    dispatch(classActions.setDeleteClass({ modal: isOpen }));
  };

  const handleDeleteClass = () => {
    dispatch(deleteClassAction(deleteClass.id));
  };

  const handleResultButton = () => {
    dispatch(
      classActions.setDeleteClass({
        modal: false,
        id: null,
        status: ReducerStatus.IDLE,
        error: null,
      })
    );
  };

  return (
    <Box>
      {/* Show ResultModal if the delete operation succeeded or failed */}
      {deleteClass.status === ReducerStatus.SUCCEEDED ||
      deleteClass.status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={deleteClass.modal}
          onSubmit={handleResultButton}
          isError={deleteClass.status === ReducerStatus.FAILED}
          title={
            deleteClass.status === ReducerStatus.SUCCEEDED
              ? 'Deleted'
              : 'Server Error'
          }
          message={
            deleteClass.status === ReducerStatus.SUCCEEDED
              ? 'The selected class has been deleted successfully. If you believe this was done in error, please contact the administrator.'
              : deleteClass.error?.data?.title || 'Server Error'
          }
        />
      ) : (
        // Show confirmation modal for delete operation
        <Modal
          isOpen={deleteClass.modal}
          onClose={() => handleToggleDeleteModal(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>Are you sure you want to delete this class?</ModalBody>

            <ModalFooter>
              {/* Close button */}
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => handleToggleDeleteModal(false)}
              >
                Close
              </Button>
              {/* Proceed button */}
              <Button
                variant="outline"
                colorScheme="red"
                isLoading={deleteClass.status === ReducerStatus.LOADING}
                onClick={() => handleDeleteClass()}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

export default DeleteClassMd;
